/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Promotion_Placements_Left_Rail_DescriptionInputs */

const en_directory_promotion_placements_left_rail_description = /** @type {(inputs: Directory_Promotion_Placements_Left_Rail_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep a sponsored product visible alongside catalog browsing.`)
};

const zh_directory_promotion_placements_left_rail_description = /** @type {(inputs: Directory_Promotion_Placements_Left_Rail_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`让赞助产品在浏览目录时持续可见。`)
};

/**
* | output |
* | --- |
* | "Keep a sponsored product visible alongside catalog browsing." |
*
* @param {Directory_Promotion_Placements_Left_Rail_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_promotion_placements_left_rail_description = /** @type {((inputs?: Directory_Promotion_Placements_Left_Rail_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Promotion_Placements_Left_Rail_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_promotion_placements_left_rail_description(inputs)
	return zh_directory_promotion_placements_left_rail_description(inputs)
});
export { directory_promotion_placements_left_rail_description as "directory.promotion.placements.left-rail.description" }